// This function will maintain the pdp state when there is any change in cart drawer
function FreeBracelet() {
  const isFreeBraceletCollectionPage = document.querySelector('.free-bracelets-collection-page');
  const isFreeBraceletProductPage = document.querySelector('.free-bracelet-product-page');

  // This function will be handling the pdp state by showing and hiding the submit and unavailable button
  async function init() {
    const currentBraceletContainer = document.querySelector('product-info');
    const submitButton = currentBraceletContainer.querySelector('.product-form__submit');
    const currentBraceletHandle = currentBraceletContainer.getAttribute('data-handle');
    const notAvailableButton = currentBraceletContainer.querySelector('.product-form__unavailable-button');
    // current bracelet details.
    const currentBraceletDetail = await productDetails(currentBraceletHandle);

    // This function will be handling the pdp state by showing and hiding the submit and unavailable button
    function handleBraceletPdpState(cart) {
      // reverting the disabled state of submit button
      if (submitButton.children[0].innerText !== 'Out of stock') {
        submitButton.removeAttribute('disabled');
      }

      if (cart && currentBraceletDetail) {
        var isFreeBraceletInCart = cart.items.filter((item) => {
          return item.product_id === Number(cart.attributes.is_free_bracelet_id);
        });

        // If free bracelet is there in cart and the current pdp is of free bracelet
        if (
          isFreeBraceletInCart &&
          isFreeBraceletInCart.length &&
          currentBraceletDetail.tags.includes('freebracelet')
        ) {
          submitButton.classList.add('hidden');
          notAvailableButton.classList.remove('hidden');
        } else {
          submitButton.classList.remove('hidden');
          notAvailableButton.classList.add('hidden');
        }
      }
    }

    // Product defail api
    function productDetails(handle) {
      return window
        .fetch(`/products/${handle}.js`, {
          credentials: 'same-origin',
          method: 'GET',
        })
        .then((response) => {
          return response.json();
        });
    }

    // Cart api
    function getCart() {
      // Making submit button disabled for initial load
      submitButton.setAttribute('disabled', true);

      return window
        .fetch(`/cart.js`)
        .then((response) => response.json())
        .then((data) => {
          handleBraceletPdpState(data);
        });
    }

    getCart();
  }

  function initFreeBraceletsPage() {
    // This function will be handling the pdp state by showing and hiding the submit and unavailable button
    function handleFreeBraceletPage(cart) {
      const submitButtons = document.querySelectorAll('.product-form__cart-submit');
      const notAvailableButtons = document.querySelectorAll('.product-form__unavailable-button');
      submitButtons.forEach((button) => {
        // reverting the disabled state of submit button
        if (button.children[0].innerText !== 'Out of stock') {
          button.removeAttribute('disabled');
        }
      });

      if (cart) {
        const isFreeBraceletInCart = cart.items.filter((item) => {
          return item.product_id === Number(cart.attributes.is_free_bracelet_id);
        });

        // If free bracelet is there in cart and the current pdp is of free bracelet
        if (isFreeBraceletInCart && isFreeBraceletInCart.length) {
          submitButtons.forEach((button) => {
            button.classList.add('hidden');
          });
          notAvailableButtons.forEach((button) => {
            button.classList.remove('hidden');
          });
        } else {
          submitButtons.forEach((button) => {
            button.classList.remove('hidden');
          });
          notAvailableButtons.forEach((button) => {
            button.classList.add('hidden');
          });
        }
      }
    }

    // Cart api
    function getCart() {
      // Making all the submit buttons disabled for initial load
      const submitButtons = document.querySelectorAll('.product-form__submit');
      submitButtons.forEach((button) => {
        button.setAttribute('disabled', true);
      });

      return window
        .fetch(`/cart.js`)
        .then((response) => response.json())
        .then((data) => {
          handleFreeBraceletPage(data);
        });
    }

    getCart();
  }

  if (isFreeBraceletProductPage) {
    init();
  }

  if (isFreeBraceletCollectionPage) {
    initFreeBraceletsPage();
  }
}
window.updateFreeBraceletState = FreeBracelet;
const isFreeBraceletCollectionPage = document.querySelector('.free-bracelets-collection-page');
if (document.body.classList.contains('template-product-bracelets') || isFreeBraceletCollectionPage) {
  FreeBracelet();
}
